import { jsx as _jsx } from "react/jsx-runtime";
import { Link as RouterLink } from 'react-router-dom';
import { EM_DASH } from 'libs.constants';
import { useLocalizeMessage, Link, Badge, Dropdown, useDialog } from 'libs.nucleus';
import { getStatusBadgeVariant, getStatusLabel } from '../../utils';
export const useChartsColumns = ({ archiveChart }) => {
    const translate = useLocalizeMessage();
    const dialog = useDialog();
    const onArchiveChart = async (chart) => {
        const ok = await dialog.open({
            title: translate('Confirm archival?'),
            body: translate('Are you sure you want to archive this chart? Confirming will remove this chart from the main list and make it no longer editable. You can still view it via the "Show archived" filter.'),
            actionButtons: [{ isDestructive: true, label: translate('Yes, archive') }, { label: translate('No, cancel') }],
        });
        if (ok) {
            archiveChart(chart);
        }
    };
    return [
        {
            header: translate('Name'),
            accessorKey: 'name',
            enableSorting: true,
            cell: (value) => {
                const chart = value.row.original;
                return (_jsx(Link, { LinkComponent: RouterLink, to: `/library/charts/${chart.id}`, children: value.getValue() }));
            },
            size: 250,
        },
        {
            header: translate('Description'),
            accessorKey: 'description',
            accessorFn: (chart) => chart.metadata?.description || EM_DASH,
            enableSorting: false,
            size: 400,
        },
        {
            header: translate('Version'),
            accessorKey: 'version',
            enableSorting: true,
            cell: ({ row }) => _jsx(Badge, { label: `v${row.original.version}` }),
            size: 120,
        },
        {
            header: translate('Status'),
            accessorKey: 'status',
            enableSorting: true,
            size: 150,
            cell: (value) => {
                const status = value.getValue();
                return _jsx(Badge, { label: getStatusLabel(status, translate), variant: getStatusBadgeVariant(status) });
            },
        },
        {
            header: '',
            accessorKey: 'id',
            size: 50,
            cell: ({ row }) => {
                const chart = row.original;
                const isArchived = chart.active === false;
                // Don't show actions menu for archived charts
                if (isArchived) {
                    return null;
                }
                const items = [
                    {
                        content: translate('Archive'),
                        id: 'archive-' + chart.id,
                        onClick: () => onArchiveChart(chart),
                    },
                ];
                return _jsx(Dropdown, { variant: 'kebab', position: 'bottom-end', items: items });
            },
            enableSorting: false,
        },
    ];
};
